import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
;
@Injectable()
export class AppConfiguaration {
  private readonly http = inject(HttpClient)
  private config: Object = null;
  private env: Object = null;
  constructor() { }
  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    if (this.config) {
      const configValue = this.config[key];
      return configValue;
    } else {
      return null;
    }
  }
  /**
   * Use to get the data found in the first file (env file)
   */
  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  public load() {
    return new Promise((resolve, reject) => {
      // Always prioritize __CMS_ASSET_BASE__ if set - this should point to the correct asset server
      // (e.g., https://cms-dev.coherentpixels.com/single-spa)
      let base = (window as any).__CMS_ASSET_BASE__ || '';
      // If base is not set, try to infer it from webpack public path
      if (!base) {
        try {
          // @ts-ignore
          const webpackPublicPath = typeof __webpack_public_path__ !== 'undefined' ? __webpack_public_path__ : '';
          if (webpackPublicPath) {
            // Remove trailing slash if present
            base = webpackPublicPath.replace(/\/$/, '');
          }
        } catch (e) {
          console.warn('[AppConfig] Error reading webpack public path:', e);
        }
      } else {
        console.warn('[AppConfig] Using __CMS_ASSET_BASE__:', base);
      }
      // If still no base, fallback to relative paths
      if (!base) {
        console.warn('[AppConfig] No base URL found, using relative paths');
      }
      // Construct the env.json URL - always use the base if available
      // This ensures we load from https://cms-dev.coherentpixels.com/single-spa/assets/env/env.json
      const envUrl = base ? `${base}/assets/env/env.json` : `./assets/env/env.json`;
      this.http.get(envUrl)
        .pipe(
          map(res => {
            return res;
          })
        )
        .subscribe({
          next: (envResponse) => {
            this.env = envResponse;
            if (envResponse?.['env']) {
              // Use the same base URL for config file
              const cfgUrl = base ? `${base}/assets/config/env.${envResponse['env']}.json` : `./assets/config/env.${envResponse['env']}.json`;
              this.http.get(cfgUrl).subscribe({
                next: (responseData: any) => {
                  this.config = responseData;
                  resolve(true);
                },
                error: (err) => {
                  console.error('[AppConfig] Error loading config file:', err);
                  console.error('[AppConfig] Config URL attempted:', cfgUrl);
                  // Resolve anyway to allow app to continue
                  resolve(true);
                }
              });
            } else {
              console.error('[AppConfig] Env config file "env.json" is not valid or missing "env" property');
              resolve(true);
            }
          },
          error: (error) => {
            console.error('[AppConfig] Error loading env.json from:', envUrl, error);
            // Only try relative path as fallback if base URL failed
            if (base) {
              this.http.get('./assets/env/env.json').subscribe({
                next: (envResponse) => {
                  this.env = envResponse;
                  if (envResponse?.['env']) {
                    const cfgUrl = `./assets/config/env.${envResponse['env']}.json`;
                    this.http.get(cfgUrl).subscribe({
                      next: (responseData: any) => {
                        this.config = responseData;
                        resolve(true);
                      },
                      error: (err) => {
                        console.error('[AppConfig] Fallback config load failed:', err);
                        resolve(true);
                      }
                    });
                  } else {
                    resolve(true);
                  }
                },
                error: (fallbackError) => {
                  console.error('[AppConfig] Fallback also failed:', fallbackError);
                  resolve(true);
                }
              });
            } else {
              resolve(true);
            }
          }
        });
    });
  }
}